module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('datepicker', {
    ref: "datepicker",
    attrs: {
      "name": _vm.name,
      "bootstrapStyling": true,
      "monday-first": true,
      "id": _vm.id,
      "disabled": _vm.readonly,
      "disabledDates": _vm.internalDisabled,
      "placeholder": _vm.placeholder,
      "format": _vm.$t("format.datepicker")
    },
    on: {
      "opened": _vm.onOpened,
      "closed": _vm.onClosed
    },
    model: {
      value: (_vm.internalValue),
      callback: function($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c08a5738"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/correct-datepicker/CorrectDatepicker.vue
// module id = 962
// module chunks = 1